import React, { useState, useEffect } from "react"

export default function NewsletterOverlay({ active, onClose }) {
    const [formData, setFormData] = useState({ name: "", surname: "", postCode: "", email: "" })
    const [submitted, setSubmitted] = useState(false)

    const handleInput = e => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }))

    const handleClose = () => {
        onClose()
        setTimeout(() => {
            setFormData({ name: "", surname: "", postCode: "", email: "" })
            setSubmitted(false)
        }, 650)
    }

    const handleSubmit = e => {
        e.preventDefault()
        const body = new URLSearchParams({
            "form-name": "newsletter-subscribe",
            name: formData.name,
            surname: formData.surname,
            "post-code": formData.postCode,
            email: formData.email,
        })
        fetch("/", { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: body.toString() })
            .then(() => setSubmitted(true))
            .catch(() => setSubmitted(true))
    }

    useEffect(() => {
        const handleEscape = e => {
            if (e.key === "Escape" && active) handleClose()
        }
        window.addEventListener("keydown", handleEscape)
        return () => window.removeEventListener("keydown", handleEscape)
    }, [active])

    useEffect(() => {
        if (active) document.body.style.overflow = "hidden"
        else document.body.style.overflow = ""
        return () => {
            document.body.style.overflow = ""
        }
    }, [active])

    return (
        <>
            <form hidden name='newsletter-subscribe' data-netlify='true'>
                <input type='hidden' name='form-name' value='newsletter-subscribe' />
                <input name='name' />
                <input name='surname' />
                <input name='post-code' />
                <input name='email' />
            </form>
            <div className={`resource-overlay${active ? " active" : ""}`} onClick={handleClose}>
                <div className='resource-overlay-content' onClick={e => e.stopPropagation()}>
                    <button className='resource-overlay-close' onClick={handleClose} type='button' />
                    {submitted ? (
                        <ThankYou />
                    ) : (
                        <>
                            <p className='h3 mb20'>Subscribe to our newsletter for occasional updates and exclusive content</p>
                            <form method='POST' data-netlify='true' netlify-honeypot='bot-field' name='newsletter-subscribe' onSubmit={handleSubmit}>
                                <input type='hidden' name='form-name' value='newsletter-subscribe' />
                                <input type='hidden' name='bot-field' />
                                <div className='resource-overlay-grid'>
                                    <InputField label='Name' name='name' value={formData.name} onChange={handleInput} />
                                    <InputField label='Surname' name='surname' value={formData.surname} onChange={handleInput} className='mln1' />
                                    <InputField label='Post Code' name='postCode' value={formData.postCode} onChange={handleInput} className='mln1' />
                                    <EmailField value={formData.email} onChange={handleInput} onSubmit={handleSubmit} />
                                </div>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

function InputField({ label, name, type = "text", value, onChange, className = "" }) {
    return (
        <div className={`corner-box form-cell form-input-cell${className ? " " + className : ""}`}>
            <span className='form-cell-label p-sans'>{label}</span>
            <input className='form-input h2' type={type} name={name} value={value} onChange={onChange} />
        </div>
    )
}

function EmailField({ value, onChange, onSubmit }) {
    return (
        <div className='corner-box form-cell form-input-cell resource-overlay-full'>
            <span className='form-cell-label p-sans'>Email</span>
            <input className='form-input h2' type='email' name='email' value={value} onChange={onChange} />
            <div className='form-bottom flex align-center space-between flex-wrap gap-20 mta'>
                <span className='p-sans f-15 m-12'>
                    By submitting this form you accept our{" "}
                    <a href='/privacy' className='underline'>
                        Privacy Policy
                    </a>
                    .
                </span>
                <button type='submit' className='form-submit p-sans'>
                    Submit &rarr;
                </button>
            </div>
        </div>
    )
}

function ThankYou() {
    return (
        <div className='form-thank-you flex flex-col gap-10 align-center justify-center'>
            <h2 className='h2'>Thank you for subscribing.</h2>
        </div>
    )
}
